import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Terms = () => {
    return (
        <div className="landing-page">
            <main className="policy-content" style={{ paddingTop: '120px', paddingBottom: '100px', maxWidth: '800px', margin: '0 auto', paddingLeft: '7.6923%', paddingRight: '7.6923%' }}>
                <Link to="/" className="back-link" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--brand-primary)', textDecoration: 'none', marginBottom: '40px' }}>
                    <ArrowLeft size={20} />
                    Back to Home
                </Link>

                <h1 className="section-title" style={{ textAlign: 'left', marginBottom: '40px' }}>Terms of Service</h1>

                <div className="policy-text" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                    <p style={{ marginBottom: '20px' }}>Last Updated: January 8, 2026</p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>1. Acceptance of Terms</h2>
                    <p style={{ marginBottom: '20px' }}>
                        By accessing or using the services provided by Adjactive ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our Service.
                    </p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>2. Description of Service</h2>
                    <p style={{ marginBottom: '20px' }}>
                        Adjactive provides AI security auditing, red teaming, and compliance services. The specific scope of services provided will be governed by a separate Service Agreement between you and Adjactive/Hakxcore.
                    </p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>3. User Responsibilities</h2>
                    <p style={{ marginBottom: '20px' }}>
                        You are responsible for ensuring that you have all necessary rights and permissions for the AI systems and data you provide to Adjactive for auditing. You agree not to use the Service for any unlawful or unauthorized purpose.
                    </p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>4. Intellectual Property</h2>
                    <p style={{ marginBottom: '20px' }}>
                        All content on the Adjactive website, including text, graphics, logos, and software, is the property of Adjactive or its licensors and is protected by intellectual property laws.
                    </p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>5. Limitation of Liability</h2>
                    <p style={{ marginBottom: '20px' }}>
                        Adjactive and Hakxcore shall not be liable for any indirect, incidental, or consequential damages arising out of your use of the Service, except as expressly provided in a signed Service Agreement.
                    </p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>6. Governing Law</h2>
                    <p style={{ marginBottom: '20px' }}>
                        These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Hakxcore is registered.
                    </p>
                </div>
            </main>
        </div>
    );
};

export default Terms;
